import type {
  ContactListChannel,
  ContactListConsent,
  OnboardingContactList,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1109 — the contact list, admin only. The API logs every patient it
// returns as a read on the support basis; PDL purpose: administration.

const BASE = `${API_BASE}/employee-api/v1/onboarding-funnel/contacts`;

/** `from`/`to` are inclusive Stockholm days of the start, YYYY-MM-DD. */
export async function fetchContactList(
  from: string,
  to: string,
  filter: {
    channel: ContactListChannel | null;
    consent: ContactListConsent | null;
  },
): Promise<OnboardingContactList> {
  const qs = new URLSearchParams({ from, to });
  if (filter.channel) qs.set("channel", filter.channel);
  if (filter.consent) qs.set("consent", filter.consent);
  const res = await apiFetch(`${BASE}?${qs}`, {
    headers: { ...commonHeaders(), "X-Access-Purpose": "administration" },
    ...withCredentials,
  });
  return jsonOr401(res);
}
